import React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';

import SecondaryCta from 'components/Buttons/SecondaryCta';
import { StyledTypographyColorSectionNavLinkMain } from 'components/Cart/StyledTypographyColorSectionNavLinkMain';

import { MENU_ITEM_NAMES } from 'styles/constants/appearanceSectionNames';
import { getOwnCartDrawerState } from 'styles/helpers/getSecondaryButtonState';
import { EMPTY_CART_CONFIRMATION_MODAL } from 'constants/cart';
import useIsCaliforniaLocationWithServiceFee from 'bento-ordering/hooks/useIsCaliforniaLocationWithServiceFee';
import HonestPricingLawCartMessage from 'bento-ordering/cart/components/HonestPricingLawCartMessage';

const flexProps = {
  justifyContent: 'space-between',
  display: 'flex'
};

function CartInfoWithNoTax({
  toggleIsOpen,
  subtotal,
  onlineOrderingServiceFee
}) {
  const totalStyles = { variant: MENU_ITEM_NAMES };
  const cartSubtotal =
    parseFloat(subtotal) + parseFloat(onlineOrderingServiceFee);
  const shouldRenderCaliforniaServiceFee = useIsCaliforniaLocationWithServiceFee();
  return (
    <Box marginTop={2} marginBottom={2}>
      <Box marginBottom={2} {...flexProps}>
        <StyledTypographyColorSectionNavLinkMain
          {...totalStyles}
          fontSize="16px"
          fontWight={500}
        >
          Subtotal
        </StyledTypographyColorSectionNavLinkMain>
        <StyledTypographyColorSectionNavLinkMain
          {...totalStyles}
          fontSize="16px"
          data-testid="cart-total"
        >
          ${subtotal}
        </StyledTypographyColorSectionNavLinkMain>
      </Box>
      {shouldRenderCaliforniaServiceFee && (
        <HonestPricingLawCartMessage
          onlineOrderingServiceFee={onlineOrderingServiceFee}
          cartSubtotal={cartSubtotal}
        />
      )}
      <SecondaryCta
        handleClick={() => toggleIsOpen(EMPTY_CART_CONFIRMATION_MODAL)}
        label="Empty Cart"
        dataTestId="cart-empty-button"
        ownState={getOwnCartDrawerState()}
      />
    </Box>
  );
}

CartInfoWithNoTax.propTypes = {
  toggleIsOpen: PropTypes.func,
  subtotal: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  tipAmount: PropTypes.string,
  onlineOrderingServiceFee: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ])
};

export default CartInfoWithNoTax;
